module.exports = __webpack_public_path__ + "static/Unbenannt-3-faa0be851a239159347174b2f73ff606.jpg";